// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-7381548e] {\n  font-size: 12px;\n  line-height: 2;\n}", ""]);
// Exports
module.exports = exports;
